import { SET_PROPS, PROPS } from './types'

export const propsAction = {
  setProps: (payload?: any): PROPS => ({ type: SET_PROPS, payload }),
}
